

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEEMAILCONFIG= createAsyncThunk(
  "updateEmailConfig/updateEmailConfig",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateEmailConfigSlice = createSlice({
  name: "updateEmailConfigSlice",
  initialState: {
    updateEmailConfig: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateEmailConfig: (state) => {
        state.updateEmailConfig.loading = false
        state.updateEmailConfig.error = false
        state.updateEmailConfig.data = []
        state.updateEmailConfig.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEEMAILCONFIG.fulfilled, (state, action) => {
      state.updateEmailConfig = {
        ...state.updateEmailConfig,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEMAILCONFIG.pending, (state, action) => {
      state.updateEmailConfig = {
        ...state.updateEmailConfig,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEMAILCONFIG.rejected, (state, action) => {
      state.updateEmailConfig = {
        ...state.updateEmailConfig,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateEmailConfigAction = {
    UPDATEEMAILCONFIG,
};

export { updateEmailConfigAction };
export default updateEmailConfigSlice.reducer;
export const {setInitialStateOfupdateEmailConfig} = updateEmailConfigSlice.actions
